import React, { useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../Contexts/AuthenticateProvider";
import { reloadWindowToPath } from "../Helpers/Utils";
import Handler from "../Helpers/Components/Handler"

const Subadmin = () => {
    const [detail, setDetail] = useState({ email: "", password: "", otp: "", setPhone: false, phone: "" });
    const [disable, setDisable] = useState(false)
    const validPhoneNumber = new RegExp('^[6-9]{1}[0-9]{9}');
    const [show, setShow] = useState(false)
    const { logIn } = useAuth()
    const [password, setPassword] = useState({ password: "", confirmPassword: "", otp: "", phone: "", sentOtp: false, modal: false })
    const handleSubmit = async () => {
        if ((!validPhoneNumber.test(detail?.phone))) {
            toast.error("Invalid Phone Number");
        } else if (detail?.password === "") {
            toast.error("Password is required")
        } else {
            setDisable(true)
            const response = await Handler({ method: "post", data: detail, url: `/auth-subadmin/login` })
            if (response?.success) {
                toast.success(response?.message);
                logIn(response?.data, "subadmin");
            } else {
                setDisable(false)
                toast.error(response?.message);
            }
        }
    }
    const handleChange = (e) => {
        setDetail((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }));
    }
    const sendOtp = async () => {
        setDisable(true)
        const response = await Handler({ method: "post", url: `/auth-subadmin/send/otp`, data: { phone: password.phone } })
        if (response?.success) {
            toast.success(response?.message);
            setPassword((prev) => ({ ...prev, sentOtp: true }))
        } else {
            toast.error(response?.message);
        }
        setDisable(false)
    }
    const passwordChange = async () => {
        setDisable(true)
        const response = await Handler({ method: "patch", url: `/auth-subadmin/password/change`, data: { phone: password.phone, password: password.password, otp: password.otp } })
        if (response?.success) {
            toast.success(response?.message);
            setTimeout(() => {
                reloadWindowToPath("/");
            }, 1500);
        } else {
            setDisable(false)
            toast.error(response?.message);
        }
    }
    const changePassword = async () => {
        if (!password.phone || (!validPhoneNumber.test(password?.phone))) {
            toast.error("Invalid Phone Number")
            return
        }
        if (!password.password) {
            toast.error("Invalid Password")
            return
        }
        if (password.confirmPassword !== password.password) {
            toast.error("Password and Confirm password not equal")
            return
        }
        if (password.sentOtp && (!password.otp || password.otp?.length !== 6)) {
            toast.error("Invalid OTP")
            return
        }
        if (password.sentOtp) {
            passwordChange()
        } else {
            sendOtp()
        }
    }
    const handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (password.modal) changePassword()
            else handleSubmit();
        }
    };
    return (
        <React.Fragment>
            {
                password.modal ?
                    <>
                        <button className="btn btn-sm border-0 text-underline p-0" onClick={() => setPassword({ password: "", confirmPassword: "", otp: "", phone: "", sentOtp: false, modal: false })}>Go Back</button>
                        <div className="my-3">
                            <label htmlFor="phone" className="mb-1"> Phone Number</label>
                            <input disabled={disable || password.sentOtp} autoComplete="off" className="form-control input-theme" id="phone" name="phone" placeholder="Phone Number" onKeyUp={handleKeyUp} value={password?.phone || ""} onChange={
                                (e) => {
                                    if (/^\d{0,}$/.test(e.target.value) || e.target.value === "") {
                                        setPassword((prev) => ({ ...prev, phone: e.target.value }))
                                    }
                                }
                            } type="text" maxLength={10} />
                        </div>
                        <div className="my-3">
                            <label htmlFor="password" className="mb-1"> Password </label>
                            <div className="input-group">
                                <input disabled={disable || password.sentOtp} autoComplete="off" id="password" name="password" className="form-control input-theme " placeholder="******" onKeyUp={handleKeyUp} value={password?.password || ""} onChange={(e) => setPassword((prev) => ({ ...prev, password: e.target.value }))} type="text" />
                            </div>
                        </div>
                        <div className="my-3">
                            <label htmlFor="confirmPassword" className="mb-1"> Confirm Password </label>
                            <div className="input-group">
                                <input disabled={disable || password.sentOtp} autoComplete="off" id="confirmPassword" name="confirmPassword" className="form-control input-theme " placeholder="******" onKeyUp={handleKeyUp} value={password?.confirmPassword || ""} onChange={(e) => setPassword((prev) => ({ ...prev, confirmPassword: e.target.value }))} type="text" />
                            </div>
                        </div>
                        <div className="my-3">
                            <label htmlFor="otp" className="mb-1"> OTP</label>
                            <div className="input-group">
                                <input disabled={!password?.sentOtp || disable} autoComplete="off" id="otp" name="otp" className="form-control password-input input-theme" placeholder="OTP" onKeyUp={handleKeyUp} value={password?.otp || ""} maxLength={6} onChange={(e) => {
                                    if (/^\d{0,}$/.test(e.target.value) || e.target.value === "") {
                                        setPassword(prev => ({ ...prev, otp: e.target.value }))
                                    }
                                }} type="text" />
                                <button disabled={!password?.sentOtp || disable} className={`${!password?.sentOtp || disable ? "disabledBtn " : ""} input-group-text password-icon resend`} id="btn_1" onClick={sendOtp}> Resend OTP</button>
                            </div>
                        </div>
                        <div className="text-center"><button type="button" className="btn btn-theme mt-2 w-100" disabled={disable} onClick={changePassword}>{disable ? <i className="fa-solid fa-spinner fa-spin"></i> : (password?.sentOtp ? "Change Password" : "Send OTP")}</button></div>
                    </>
                    :
                    <>
                        <div className="my-3">
                            <label htmlFor="phone" className="mb-1"> Phone Number</label>
                            <input disabled={disable} autoComplete="off" className="form-control input-theme" id="phone" name="phone" placeholder="Phone Number" onKeyUp={handleKeyUp} value={detail?.phone || ""} onChange={
                                (e) => {
                                    if (/^\d{0,}$/.test(e.target.value) || e.target.value === "") {
                                        handleChange(e)
                                    }
                                }
                            } type="text" maxLength={10} />
                        </div>
                        <div className="my-3 mb-2">
                            <label htmlFor="password" className="mb-1"> Password </label>
                            <div className="input-group">
                                <input disabled={disable} autoComplete="off" id="password" name="password" className="form-control input-theme password-input" placeholder="******" onKeyUp={handleKeyUp} value={detail?.password || ""} onChange={handleChange} type={show ? "text" : "password"} />
                                <span className="input-group-text password-icon">{show ? <i className="fa-regular fa-eye-slash cursor-pointer" onClick={() => setShow(!show)}></i> : <i className="fa-regular fa-eye cursor-pointer" onClick={() => setShow(!show)}></i>}</span>
                            </div>
                        </div>
                        <div className="text-end"><button className="btn btn-sm border-0 text-underline p-0" onClick={() => setPassword((prev) => ({ ...prev, modal: true }))}>Change Password</button></div>
                        <div className="text-center"><button type="button" className="btn btn-theme mt-2 w-100" disabled={disable} onClick={handleSubmit}>{disable ? <i className="fa-solid fa-spinner fa-spin"></i> : "Login"}</button></div>
                    </>
            }

        </React.Fragment>
    )
}

export default Subadmin;